export default "__VITE_PUBLIC_ASSET__5bfb2df3__"